/**
 * App root — sets up routing, auth guards, layout shell, and box state.
 * Replaces the temporary hash-based router with react-router-dom.
 */

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout';
import { AuthGuard } from './auth/AuthGuard';
import { BoxProvider } from './store/BoxContext';
import { ErrorBoundary } from './components/ErrorBoundary';
import { SignInPage } from './pages/SignInPage';
import { SignUpPage } from './pages/SignUpPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { ScannerPage } from './pages/ScannerPage';
import { DashboardPage } from './pages/DashboardPage';
import { BoxListPage } from './pages/BoxListPage';
import { BoxDetailPage } from './pages/BoxDetailPage';
import { SearchPage } from './pages/SearchPage';
import { LabelsPage } from './pages/LabelsPage';
import { MarkersPage } from './pages/MarkersPage';
import { SettingsPage } from './pages/SettingsPage';
import { InventoryReportPage } from './pages/InventoryReportPage';
import { AcceptInvitePage } from './pages/AcceptInvitePage';

function ProtectedRoutes() {
  return (
    <AuthGuard>
      <BoxProvider>
        <Layout authenticated>
          <ErrorBoundary>
            <Routes>
              <Route path="/" element={<ScannerPage />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/boxes" element={<BoxListPage />} />
              <Route path="/boxes/:id" element={<BoxDetailPage />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/labels" element={<LabelsPage />} />
              <Route path="/markers" element={<MarkersPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/report" element={<InventoryReportPage />} />
              <Route path="/invite/:code" element={<AcceptInvitePage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </ErrorBoundary>
        </Layout>
      </BoxProvider>
    </AuthGuard>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public routes */}
        <Route
          path="/sign-in"
          element={
            <Layout>
              <SignInPage />
            </Layout>
          }
        />
        <Route
          path="/sign-up"
          element={
            <Layout>
              <SignUpPage />
            </Layout>
          }
        />
        <Route
          path="/reset-password"
          element={
            <Layout>
              <ResetPasswordPage />
            </Layout>
          }
        />

        {/* Protected routes — all other paths */}
        <Route path="/*" element={<ProtectedRoutes />} />
      </Routes>
    </BrowserRouter>
  );
}
